module.exports = __webpack_public_path__ + "assets/images/cinema.a3c6624495f832b539ac5afbc29fdb0b.svg";